<template>
  <div>
    <div v-if="tag !== ''" :class="isFixed ? 'isFixed' : ''">
      <div class="about">
        关于<span>“{{tag}}”</span>的最新资讯内容
      </div>
      <div class="cut-off"></div>
    </div>
    <div>
      <div v-for="item in articleAbout" class="subarticle">
        <div @click="detailsJump(item)" class="pictureArticle">
          <img :src="serverSrc + item.typeImg" />
        </div>
        <div class="descriptionArticle">
          <div class="article-title" @click="detailsJump(item)">{{ item.title }}</div>
          <div @click="detailsJump(item)" class="dateArticle">
            {{ item.releaseDate.slice(0, 10) }}&nbsp;&nbsp;{{ item.releaseDate.slice(10, 18) }}
          </div>
          <div class="contents-article" @click="detailsJump(item)">
            <span v-if="item.description !== 'null'">{{ item.description }}</span>
          </div>
          <div class="tagArticle">
            <div class="test">标签：</div>
            <div class="">
              <div @click="jumpTag(subitem)" v-for="subitem in item.contentTag" class="tag">
                {{ subitem.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination @current-change="getFrontier" :current-page.sync="frontierArticleData.pageNo" background layout="prev, pager, next" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {getContentInfo} from "../api/frontierPage";

  export default {
    name: "FrontierAboutArticle",
    props:{
      top:0,
      tag: '',
      tagInfo: {}
    },
    data() {
      return{
        articleAbout: [],
        total: 0,
        frontierArticleData: {
          channelId: 291,
          pageSize: 10,
        },
        isFixed: false,
        articleData: {
          channelId: 285,
          pageSize: 10,
        },
        currentPage: 1,
        serverSrc: "http://www.jxdinfo.com/",
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);
      if(this.tag !== ''){
        this.clickTag(this.tagInfo)
      } else {
        this.getFrontier();
      }
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods:{
      handleScroll () {
        this.$nextTick(() => {
          //计算绑定div位置
          this.$emit('getTop')
          let breadcrumbTop = this.top
          this.isFixed = breadcrumbTop <= 80;
        })
      },
      detailsJump(item) {
        item.channelId = this.articleData.channelId;
        this.$emit('openDetail',item)
      },
      getFrontier(pageNo,type,channelId) {
        const self = this;
        self.frontierArticleData.pageNo = pageNo || 1
        self.frontierArticleData.channelId = channelId || self.frontierArticleData.channelId
        if(type === '1'){ //从上页el-breadcrumb跳转前沿
          this.tag = ''
        }
        getContentInfo(self.frontierArticleData).then((res) => {
          if (res.status === 200) {
            this.articleAbout = res.data.content;
            this.total = res.data.total;
          }
        });
      },
      getAllFrontier(pageNo,type) {
        const self = this;
        self.articleData.pageNo = pageNo || 1
        if(type === '1'){ //从上页el-breadcrumb跳转前沿
          self.articleData.tagId = ''
          this.tag = ''
        }
        getContentInfo(self.articleData).then((res) => {
          if (res.status === 200) {
            this.articleAbout = res.data.content;
            this.total = res.data.total;
          }
        });
      },
      clickTag(item) {
        const self = this;
        self.tag = item.name
        self.articleData.pageNo = 1
        self.articleData.tagId = item.id || ''
        getContentInfo(self.articleData).then((res) => {
          if (res.status === 200) {
            this.articleAbout = res.data.content;
            this.total = res.data.total;
          }
        });
      },
      jumpTag(item) {
        this.$emit('jumpTag', item)
      },
    }
  }
</script>

<style scoped>
  .isFixed {position: fixed;top: 80px;width: 750px;z-index: 1000;background: #ffffff;padding-top: 20px}
  .about {align-items: center;display: flex;top: 0;position: sticky;font-size: 18px;font-weight: 700;color: #3E3A39;margin-bottom: 14px}
  .about span {color: #408CF6;}
  .cut-off {background: #E7ECF0;height: 1px;margin-bottom: 11px}
  .subarticle {box-shadow: 0 0 30px 0 rgb(11 60 139 / 8%);transition: all 0.3s ease;margin-bottom: 25px;display: flex;padding: 20px;}
  /*.subarticle:first-of-type {margin-top: 30px;}*/
  .subarticle:hover {transform: translateY(-10px);}
  .subarticle:hover .article-title {color: #408cf6;}
  .pictureArticle {flex-shrink: 0;background-size: 100% 100%;height: 184px;width: 288px;}
  .pictureArticle img {width: 100%;height: 100%;}
  .descriptionArticle {margin-left: 20px;flex-grow: 1;overflow: hidden;cursor: pointer;}
  .dateArticle {margin-top: 10px;font-size: 14px;font-weight: 400;color: #b2b0b0;}
  .article-title {font-size: 18px;font-weight: bold;color: #3e3a39;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .contents-article {line-height: 2;margin-top: 20px;font-size: 14px;font-weight: 400;color: #3e3a39;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;height: 80px}
  .tagArticle {align-items: center;display: flex;margin-top: 7px;}
  /*.tagArticle div:nth-of-type(2) {margin-left: 10px;}*/
  .tag {margin-left: 5px;display: inline-block;width: max-content;padding: 5px;color: #408cf6;cursor: pointer;font-size: 14px;}
  .test{min-width: 27px;font-size: 14px;color: #B2B0B0}
  .el-pagination{float: right;width: max-content;}
</style>



// WEBPACK FOOTER //
// src/components/FrontierAboutArticle.vue